<template>
  <div class="titulo-classe-descricao">
    <div style="display: flex;align-items: center;justify-content: center;">
      <slot>
      </slot>
      <h4 :style="{ color: cor }" class="titulo-classe-descricao-Titulo" ref="refTituloDaClasse">
        {{ titulo }}
      </h4>
    </div>
    <p v-if="subtitulo != '' && subtitulo != null">{{ subtitulo }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "TituloDePaginaView",

  props: {
    titulo: String,
    subtitulo: String,
    cor:String,
    img:String
  },

  mounted() {
    const titulo = this.$refs.refTituloDaClasse;
    if (this.$store.state.isHardRock == true) {
      if (titulo) {
        titulo.style.color = "black";
      }
    }
  },
};
</script>

<style scoped>
.titulo-classe-descricao {
  padding-inline: 0px;
  padding-top: var(--padding-padrao);
}

.titulo-classe-descricao-Titulo {
  word-break: break-word;
  font-weight: 900;
  font-size: 18px;
}

.titulo-classe-descricao hr {
  margin: 0px;
  margin-inline: 10px;
}
.titulo-classe-descricao p {
  margin: 10px;
  font-size: 13px;
  color: white;
  text-align: justify;
  text-indent: 5px;
}
</style>
